import { ajaxUrl } from '../../../../_layout/js/constants.js';

import handleAdmonParams from '../../../../_layout/js/handleAdmonParams.js';
import setAppLink from '../../../../_layout/js/setAppLink.js';
import setAppsListLink from '../../../../_layout/js/setAppsListLink.js';

$(document).ready(function() {
    setAppLink();

    $.ajax({
        url: ajaxUrl,
        method: 'GET',
        dataType: 'json', 
        success: function(responseData) {
            if (!responseData?.systemSettings) {
                console.error('Отсутствует systemSettings');
                return null;
            }

            setAppsListLink(responseData.systemSettings);
        },
        error: function(error) {
            console.error('Ошибка запроса:', error);
        }
    });

    new Swiper('.js-slider', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: '.slider__controls',
            bulletClass: 'dotted',
            bulletActiveClass: 'dotted--active',
            clickable: true,
        },
    });

    handleAdmonParams();
});



// WEBPACK FOOTER //
// ./p/mobile/download/src/entry-point.js